export namespace LogicalLinkHelpers {
  export function shouldLogicalLinkBeForwardOpen(logicalLinkName: string): boolean {
    if (!logicalLinkName) {
      return false;
    }

    return new RegExp('^LL_.*_CAN.*_CAN.*$').test(logicalLinkName);
  }
}
